var fullImgSlide = {
	targetEl: $('.full-bleed-img-carousel'),

	checkIfApplicable: function() {
		fullImgSlide.targetEl.each(function() {
			var _this = $(this);
			var slides = _this.find('.carousel-cell').length;
			if (slides > 1) {
				fullImgSlide.setUp(_this);
			}
		});
	},

	setUp: function(targetSlide) {
		targetSlide.flickity({
			wrapAround: true,
			imagesLoaded: true,
			prevNextButtons: false,
			rightToLeft: window.rtl
		});
	},

	init: function() {
		if (fullImgSlide.targetEl.length) {
			fullImgSlide.checkIfApplicable();
		}
	}
};